import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import EmptySearchSection from './EmptySearchSection';
import MyReportsSearchSection from './MyReportsSearchSection';
import { View } from 'foundations-components/components/View';
import { EMPTY_SEARCH_VALUE } from '../../constants/globalSearch';
import SearchHeader from '../../components/globalSearch/SearchHeader';
import ReportTemplatesSearchSection from './ReportTemplatesSearchSection';
import { fetchReportCollectionTemplates } from '../../redux/reportCollectionTemplates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GlobalSearchPage = ({
  search
}) => {
  const dispatch = useDispatch();
  const [showMoreMyReports, setShowMoreMyReports] = useState(false);
  const [showMoreReadyMadeReports, setShowMoreReadyMadeReports] = useState(false);
  const isEmptySearchPage = search === EMPTY_SEARCH_VALUE;
  useEffect(() => {
    void dispatch(fetchReportCollectionTemplates());
  }, [dispatch]);
  useEffect(() => {
    setShowMoreMyReports(false);
    setShowMoreReadyMadeReports(false);
    // only trigger event when there is a new search value
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "global-search-page",
    inlineSize: "auto",
    children: [/*#__PURE__*/_jsx(SearchHeader, {}), /*#__PURE__*/_jsx(View, {
      padding: "800",
      children: isEmptySearchPage ? /*#__PURE__*/_jsx(EmptySearchSection, {}) : /*#__PURE__*/_jsxs("div", {
        "data-test-id": "global-search-results",
        children: [!showMoreReadyMadeReports && /*#__PURE__*/_jsx(MyReportsSearchSection, {
          showMore: showMoreMyReports,
          setShowMore: setShowMoreMyReports,
          search: search
        }), !showMoreMyReports && /*#__PURE__*/_jsx(ReportTemplatesSearchSection, {
          showMore: showMoreReadyMadeReports,
          setShowMore: setShowMoreReadyMadeReports
        })]
      })
    })]
  });
};
export default GlobalSearchPage;